import React from 'react';
import { useTranslation } from 'react-i18next';

export function FilterPresetSaveButton({ onClick, className = '' }) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={`btn btn-outline-secondary ${className}`.trim()}
      aria-label={t('filterPresets.saveCurrent')}
      title={t('filterPresets.saveCurrent')}
      onClick={onClick}
    >
      <i className="ti ti-device-floppy" aria-hidden="true"></i>
    </button>
  );
}

export function FilterPresetList({ presets, onApply, onDelete }) {
  const { t } = useTranslation();

  if (!Array.isArray(presets) || presets.length === 0) {
    return null;
  }

  return (
    <div className="app-filter-presets" aria-label={t('filterPresets.savedSearches')}>
      <span className="app-filter-presets__label">{t('filterPresets.savedSearches')}</span>
      <div className="app-filter-presets__items">
        {presets.map((preset) => (
          <div key={preset.id} className="btn-group btn-group-sm app-filter-preset-group" role="group">
            <button
              type="button"
              className="btn btn-outline-secondary app-filter-preset-chip"
              onClick={() => onApply(preset.id)}
            >
              <i className="ti ti-bookmark" aria-hidden="true"></i>
              <span>{preset.name}</span>
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary app-filter-preset-delete"
              aria-label={t('filterPresets.deletePreset', { name: preset.name })}
              title={t('filterPresets.deletePreset', { name: preset.name })}
              onClick={() => onDelete(preset.id)}
            >
              <i className="ti ti-trash" aria-hidden="true"></i>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export function FilterPresetNameModal({
  isOpen,
  name,
  error,
  onNameChange,
  onSubmit,
  onClose,
}) {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog modal-sm modal-dialog-centered">
          <form className="modal-content" onSubmit={onSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">{t('filterPresets.modalTitle')}</h5>
              <button type="button" className="btn-close" aria-label={t('common.close')} onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <label className="form-label" htmlFor="filter-preset-name">
                {t('filterPresets.nameLabel')}
              </label>
              <input
                id="filter-preset-name"
                type="text"
                className={`form-control${error ? ' is-invalid' : ''}`}
                value={name}
                autoFocus
                onChange={(event) => onNameChange(event.target.value)}
                placeholder={t('filterPresets.namePlaceholder')}
              />
              {error ? (
                <div className="invalid-feedback d-block">{t(error)}</div>
              ) : null}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
                {t('common.cancel')}
              </button>
              <button type="submit" className="btn btn-primary">
                {t('common.save')}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}
